import { FC } from 'react';
import { useMembersStore } from '../../MembersProvider';
import FlashSale from '../ActivityCom/FlashSale';
import Nav from './Nav';
import ActiveOverview from '@/components/MembersDay/FY2024/ActivityCom/ActiveOverview';
import HotBundles from '@/components/MembersDay/FY2024/ActivityCom/HotBundles';
import BestSellers from '@/components/MembersDay/FY2024/ActivityCom/BestSellers';
import BannerViewB from '@/components/MembersDay/FY2024/ActivityCom/BannerViewB';
import Accessories from '@/components/MembersDay/FY2024/ActivityCom/Accessories';
import BagIcon from '@/components/MembersDay/FY2024/ActivityCom/Icon/BagIcon';
import HotIcon from '@/components/MembersDay/FY2024/ActivityCom/Icon/HotIcon';
import StarIcon from '@/components/MembersDay/FY2024/ActivityCom/Icon/StarIcon';
import TradeIn from '@/components/MembersDay/FY2024/Return/TradeIn';
import MembersTimeLine from '@/components/MembersDay/FY2024/Teaser/MembersTimeLine';
import CelebratingUs from '@/components/MembersDay/FY2024/Teaser/CelebratingUs';
import JoinUs from '@/components/MembersDay/FY2024/Teaser/JoinUs';
import ReferralNext from '@/components/MembersDay/FY2024/Teaser/ReferralNext';
import EcoBenefits from '@/components/MembersDay/FY2024/Teaser/EcoBenefits';
import Subscribe from '@/components/MembersDay/FY2024/Teaser/Subscribe';
import Horizonta from '@/components/MembersDay/FY2024/ActivityCom/JP/Horizonta';
import MixProduct from '@/components/MembersDay/FY2024/ActivityCom/JP/MixProduct';
import PiecesProduct from '@/components/MembersDay/FY2024/ActivityCom/JP/PiecesProduct';
import getLocal from '@/app/utils/getLocal';
import { ProductModule } from '@/components/MembersDay/type';
import { useLang } from '@/i18n';
import BottomTips from '@/components/MembersDay/FY2024/Teaser/BottomTips';
import LoginCard from '@/components/MembersDay/FY2024/ActivityCom/LoginCard';
import { EU_SITES, NA_SITES } from '@/constants/membersday';

const ReturnCompoment: FC = ({}) => {
    const { locale } = getLocal();
    const { t } = useLang('membersday.return');
    const { isLogin } = useMembersStore();

    /*
        module 后端约定字段
        <HotBundles /> // 左右图文模块
        <BestSellers /> // 每排3个产品
        <BannerViewB /> // banner跳转模块
        <Accessories /> // 每排4个产品
        <Refurbished /> // 轮播产品 
    */
    // BUY_ONE_GET_ONE2\REFURBISH2\NORMAL2（uk没有）\HOT2
    const euComp = () => (
        <>
            <div className="members-day-over"></div>
            <ActiveOverview />
            <div className="members-day-over"></div>
            <Nav />
            <TradeIn />
            <HotBundles module={ProductModule.BUY_ONE_GET_ONE2} title={t('product_title2')} desc={t('product_desc2')} icon={<HotIcon />} id="nav_title_2" />
            {locale !== 'uk' && (
                <HotBundles module={ProductModule.NORMAL2} title={t('product_title4')} desc={t('product_desc4')} icon={<BagIcon />} id="nav_title_4" />
            )}
            <Accessories module={ProductModule.REFURBISH2} title={t('product_title3')} desc={t('product_desc3')} icon={<StarIcon />} id="nav_title_3" />
            <BannerViewB />
            <Accessories module={ProductModule.HOT2} title={t('product_title5')} desc={t('product_desc5')} icon={<BagIcon />} id="nav_title_5" />
            <div className="members-day-over"></div>
            <CelebratingUs />
            <div className="members-day-over"></div>
            <JoinUs />
            <div className="members-day-over"></div>
            <ReferralNext />
            <div className="members-day-over"></div>
            <EcoBenefits cls="activity" />
            <div className="members-day-over"></div>
            {!isLogin && <LoginCard />}
            <div className="members-day-over"></div>
        </>
    );

    // SEC_KILL\HOT2\ACCESSORY2\REFURBISH2（ca没有）
    const naComp = () => {
        return (
            <>
                <div className="members-day-over"></div>
                <ActiveOverview />
                <div className="members-day-over"></div>
                <Nav />
                <FlashSale />
                <BestSellers module={ProductModule.BEST_SELLERS2} title={t('product_title6')} desc={t('product_desc6')} icon={<StarIcon />} />
                <BestSellers
                    module={ProductModule.ACCESSORY2}
                    title={t('product_title3')}
                    desc={t('product_desc3')}
                    icon={<StarIcon />}
                    id="activity-BestSellers2"
                />
                {locale === 'us' && <Accessories module={ProductModule.REFURBISH2} title={t('product_title4')} desc={t('product_desc4')} icon={<BagIcon />} />}
                <HotBundles module={ProductModule.HOT2} title={t('product_title2')} desc={t('product_desc2')} icon={<HotIcon />} />
                <BannerViewB />
                <div className="members-day-over"></div>
                <CelebratingUs />
                <div className="members-day-over"></div>
                <JoinUs />
                <div className="members-day-over"></div>
                <ReferralNext />
                <div className="members-day-over"></div>
                <EcoBenefits cls="activity" />
                <div className="members-day-over"></div>
                <MembersTimeLine />
                <div className="members-day-over"></div>
            </>
        );
    };

    // NORMAL2\HOT2
    const jpComp = () => (
        <>
            <MembersTimeLine />
            <ActiveOverview />
            <div className="members-day-over"></div>
            <Nav />
            <FlashSale />
            <PiecesProduct module={ProductModule.NORMAL2} title={t('product_title2')} desc={t('product_desc2')} icon={<StarIcon />} id="activity-BestSellers" />
            <MixProduct module={ProductModule.HOT2} title={t('product_title3')} desc={t('product_desc3')} icon={<HotIcon />} />
            <PiecesProduct
                module={ProductModule.BEST_SELLERS2}
                title={t('product_title4')}
                desc={t('product_desc4')}
                icon={<HotIcon />}
                id="activity-HotBundles1"
            />
            <div className="members-day-over"></div>
            <JoinUs />
            <div className="members-day-over"></div>
            <ReferralNext />
            <div className="members-day-over"></div>
            <EcoBenefits cls="activity" />
            <div className="members-day-over"></div>
        </>
    );

    const krComp = () => (
        <>
            <div className="members-day-over"></div>
            <MembersTimeLine />
            <div className="members-day-over"></div>
            <ActiveOverview />
            <div className="members-day-over"></div>
            <Nav />
            <CelebratingUs />
            {/* <BestSellers module={ProductModule.NORMAL2} title={t('product_title2')} desc={t('product_desc2')} icon={<HotIcon />} id="nav_title_2" /> */}
            <BestSellers module={ProductModule.MEMBER} title={t('product_title3')} desc={t('product_desc3')} icon={<StarIcon />} id="nav_title_3" />
            <HotBundles module={ProductModule.NORMAL} title={t('product_title4')} desc={t('product_desc4')} icon={<BagIcon />} />
            <div className="members-day-over"></div>
            <Subscribe />
            <div className="members-day-over"></div>
            <JoinUs />
            <div className="members-day-over"></div>
            <ReferralNext />
            <div className="members-day-over"></div>
            <EcoBenefits cls="activity" />
            {!isLogin && <LoginCard />}
            <div className="members-day-over"></div>
        </>
    );

    return (
        <div className="page-activity">
            {EU_SITES.includes(locale) && euComp()}
            {NA_SITES.includes(locale) && naComp()}
            {locale === 'kr' && krComp()}
            {locale === 'jp' && jpComp()}
            <BottomTips />
        </div>
    );
};

export default ReturnCompoment;
